<template>
    <div class="mask-diff">
        <i class="el-icon-error close" @click="handleClose"></i>
        <div class="slider-img">
            <div class="swiper-container">
                <div class="diff_img_box">
                    <div class="diff_img_bottom">
                        <img :src="imgList[0]" />
                    </div>
                    <div class="diff_img_top" :style="{transform: 'translateX(' + y  + '%)', opacity: (opacity / 100).toFixed(1)}">
                        <img :src="imgList[1]" />
                    </div>
                </div>
            </div>
            <div class="swiper-slider">
                <div class="slider-item">
                    <span>透明度：</span>
                    <div class="slider-box">
                        <el-slider v-model="opacity" show-input @change="(data)=>handleSliderChange(data, 'opacity')"></el-slider>
                    </div>
                </div>
                <div class="slider-item">
                    <span>位置：</span>
                    <div class="slider-box">
                        <el-slider v-model="y" :min="-100" :max="100" show-input @change="(data)=>handleSliderChange(data, 'y')"></el-slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'sliderImg',
    props: {
        imgList: {
            type: Array,
            default: () => [
                'http://img2.baidu.com/it/u=1291861593,2434393593&fm=253&app=138&f=JPEG?w=800&h=1028',
                'http://img2.baidu.com/it/u=1291861593,2434393593&fm=253&app=138&f=JPEG?w=800&h=1028'
            ]
        }
    },
    data() {
        return {
            sliderImg: null,
            opacity:50,
            y:0
        }
    },
    mounted() {

    },
    methods: {
        handleClose() {
            this.$emit('close')
        },
        handleSliderChange(data, key) {
            this[key] = parseInt(data)
        }
    }
}
</script>
<style lang="scss" scoped>
.mask-diff{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
}
.close{
    position: fixed;
    z-index: 99;
    top: 25px;
    right: 25px;
    font-size: 32px;
    cursor: pointer;
}
.slider-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .swiper-container {
        
        flex: 1 1 0 ;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .diff_img_box {
            position: relative;
            margin-top: 20px;
            display: inline-block;
        }
        // height: 0;
        .diff_img_bottom {
        // height: 100%;
            img{
                // width: 100%;
                // height: 100%;
                max-height: 80vh;
                object-fit: contain;
                object-position: center;
            }
        }

        .diff_img_top {
            position: absolute;
            inset: 0;
            z-index: 10;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .swiper-slider{
        padding-top: 40px;
        width: 80%;
        height: 120px;
        .slider-item {
            display: flex;
            align-items: center;
            >span {
                width: 60px;
            }
            .slider-box {
                flex: 1;
            }
        }
    }
}
</style>
